import { apiRequest, retrieveAccessToken } from "./AuthenticationApi";

const frostUrl = process.env.REACT_APP_API_FROST;

export const fetchFrostData = async (id) => {
    try {
        const accessToken = retrieveAccessToken();
        const response = await apiRequest(`${frostUrl}/FROST-Server/v1.1/Things(${id})/Datastreams?$expand=Observations($expand=FeatureOfInterest($expand=Observations)),ObservedProperty`, 'GET', {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        });
        return response;
    } catch (error) {
        throw new Error(error.message || "An error occurred while fetching data.");
    }
};


export const getDatastreamByID = async (id) => {
    try {
        const accessToken = retrieveAccessToken();
        const response = await apiRequest(`${frostUrl}/FROST-Server/v1.1/Datastreams(${id})?$expand=Observations`, 'GET', {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        });
        return response;
    } catch (error) {
        throw new Error(error.message || "An error occurred while fetching data.");
    }
}; 


export const getObservationByID = async (id) => {
    try {
        const accessToken = retrieveAccessToken();
        const response = await apiRequest(`${frostUrl}/FROST-Server/v1.1/Observations(${id})?$expand=FeatureOfInterest($expand=Observations),Datastream($select=@iot.id,name)`, 'GET', {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        });
        return response;
    } catch (error) {
        throw new Error(error.message || "An error occurred while fetching data.");
    }
}; 